// Drawer menu system

const ddButtons = document.getElementsByClassName("mob-parent-button");

for (const ddButton of ddButtons) {
  ddButton.addEventListener("click", function (event) {
    event.preventDefault();
    updateDrawerScrollPosition();
    const nextElement = ddButton.nextElementSibling;
    if (nextElement) {
      nextElement.classList.add("active");
      updateSlHideVisibility();
    }
  });
}

function updateDrawerScrollPosition() {
  const Drawer = document.getElementById("mobNavDrawer");
  if (Drawer) Drawer.scrollTop = 0;
}

const ddPanels = document.querySelectorAll(".mob-secondary-level-ul, .mob-third-level-ul");

function updateSlHideVisibility() {
  const isActivePanel = Array.from(ddPanels).some(panel => panel.classList.contains("active"));
  const slHideDivs = document.getElementsByClassName("sl-hide");
  for (const slHideDiv of slHideDivs) {
    slHideDiv.classList.toggle("sl-hide-oi", isActivePanel);
  }
}

for (const ddPanel of ddPanels) {
  const backButton = ddPanel.querySelector(".nav-secondary-fo-back-button");
  if (backButton) {
    backButton.addEventListener("click", function () {
      ddPanel.classList.toggle("active");
      updateSlHideVisibility();
    });
  }
  const panelObserver = new MutationObserver(() => updateSlHideVisibility());
  panelObserver.observe(ddPanel, { subtree: true, childList: true, attributes: true, characterData: true });
}

// Accordion menu system. One category stays open per menu level so long
// subcategory lists remain in normal flow and never cover the categories below.
document.addEventListener("DOMContentLoaded", function () {
  const drawerAccordionButtons = Array.from(document.querySelectorAll(".mob-parent-accordion-button"));

  const closeAccordionButton = (button) => {
    const panel = button?.nextElementSibling;
    if (!button || !panel) return;
    button.classList.remove("active");
    button.setAttribute("aria-expanded", "false");
    panel.style.height = null;
    window.setTimeout(function () {
      if (button.classList.contains("active")) return;
      panel.classList.remove("panel-open");
      panel.setAttribute("aria-hidden", "true");
    }, 320);
  };

  drawerAccordionButtons.forEach(function (drawerAccordionButton) {
    drawerAccordionButton.addEventListener("click", function (event) {
      event.preventDefault();
      const panel = drawerAccordionButton.nextElementSibling;
      if (!panel) return;

      if (drawerAccordionButton.classList.contains("active")) {
        closeAccordionButton(drawerAccordionButton);
        return;
      }

      const currentList = drawerAccordionButton.parentElement?.parentElement;
      if (currentList) {
        Array.from(currentList.children).forEach((listItem) => {
          const siblingButton = Array.from(listItem.children).find((child) => child.classList?.contains("mob-parent-accordion-button"));
          if (siblingButton && siblingButton !== drawerAccordionButton && siblingButton.classList.contains("active")) {
            closeAccordionButton(siblingButton);
          }
        });
      }

      drawerAccordionButton.classList.add("active");
      drawerAccordionButton.setAttribute("aria-expanded", "true");
      panel.classList.add("panel-open");
      panel.setAttribute("aria-hidden", "false");
      panel.style.height = panel.scrollHeight + "px";
    });
  });
});

// Dropdown menu interaction
if (!document.querySelector('.nav-desktop-dd-btn-clickable')) {
  const navDesktopButtons = document.querySelectorAll('.nav-desktop-dd-btn');
  const headerMegaFwLists = document.querySelectorAll('.header-nav-desktop-dd-panel');
  const gcHeader = document.querySelector('.header-bar-inner');
  function applyBackgroundColor() { gcHeader?.classList.add('hovered'); }
  function removeBackgroundColor() { gcHeader?.classList.remove('hovered'); }
  navDesktopButtons.forEach((navDesktopButton) => {
    navDesktopButton.addEventListener('mouseover', applyBackgroundColor);
    navDesktopButton.addEventListener('mouseout', removeBackgroundColor);
  });
  headerMegaFwLists.forEach((headerMegaFwList) => {
    headerMegaFwList.addEventListener('mouseover', applyBackgroundColor);
    headerMegaFwList.addEventListener('mouseout', removeBackgroundColor);
  });
}

// Scrolling transition for transparent header option
const headerDiv = document.getElementById('SiteHeader');
const hadHdrTransHpInitially = headerDiv?.classList.contains('hdr-trans-hp') || false;
const hasScrollBehaviour = headerDiv?.querySelector('.hb-scroll-behaviour--scroll');
let isScrolled = false;
if (headerDiv && !hasScrollBehaviour) {
  function handleHeaderScroll() {
    const scrollPosition = window.pageYOffset;
    if (scrollPosition > 300 && !isScrolled) {
      headerDiv.classList.remove('hdr-trans-hp');
      isScrolled = true;
    } else if (scrollPosition <= 300 && isScrolled) {
      if (hadHdrTransHpInitially) headerDiv.classList.add('hdr-trans-hp');
      isScrolled = false;
    }
  }
  window.addEventListener('scroll', handleHeaderScroll);
  requestAnimationFrame(handleHeaderScroll);
}

// Menu drawer opening and closing
var navdrawermobile = document.getElementById('mobNavDrawer');
var drawbg = document.getElementById('drawBg');
var navbtns = document.querySelectorAll('.hdr-menu-button');
var navclose = document.getElementById('mobNavDrawerClose');
var lastFocusedButton = null;

function closeMenuDrawer(restoreFocus = true) {
  if (!navdrawermobile) return;
  navdrawermobile.classList.remove('open');
  drawbg?.classList.remove('open');
  document.body.classList.remove('body-lock-scroll');
  navdrawermobile.setAttribute('aria-hidden', 'true');
  navbtns.forEach(function(navbtn) {
    navbtn.setAttribute('aria-expanded', 'false');
  });
  if (typeof removeTrapFocus === 'function') {
    removeTrapFocus(restoreFocus ? lastFocusedButton : null);
  } else if (restoreFocus) {
    lastFocusedButton?.focus();
  }
  lastFocusedButton = null;
}

function openMenuDrawer(event) {
  if (!navdrawermobile) return;
  lastFocusedButton = event.currentTarget;
  navdrawermobile.classList.add('open');
  drawbg?.classList.add('open');
  document.body.classList.add('body-lock-scroll');
  navdrawermobile.setAttribute('aria-hidden', 'false');
  navbtns.forEach(function(navbtn) {
    navbtn.setAttribute('aria-expanded', navbtn === lastFocusedButton ? 'true' : 'false');
  });
  setTimeout(function() {
    if (typeof trapFocus === 'function') {
      trapFocus(navdrawermobile, navclose || navdrawermobile);
    } else {
      navclose?.focus();
    }
  }, 200);
  event.preventDefault();
}

navbtns.forEach(function(navbtn) {
  navbtn.addEventListener('click', openMenuDrawer);
});

navclose?.addEventListener('click', function() {
  closeMenuDrawer();
});

drawbg?.addEventListener('click', function() {
  closeMenuDrawer();
});

navdrawermobile?.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    event.preventDefault();
    closeMenuDrawer();
  }
});

// Desktop dropdowns for click option
var panelBg = document.querySelector('.dd-click-drawer-bg');
var lastClickedButton = null;
document.querySelectorAll('.nav-desktop-dd-btn-clickable').forEach(item => {
  item.addEventListener('click', (event) => {
    event.preventDefault();
    const panel = item.nextElementSibling;
    const isSameButton = lastClickedButton === item;
    const gcHeader = document.querySelector('.header-bar-inner');
    document.querySelectorAll('.header-nav-desktop-dd-panel').forEach(p => {
      if (p !== panel) p.classList.remove("dd-visible");
    });
    if (panel) {
      if (isSameButton) {
        panel.classList.toggle("dd-visible");
        panelBg?.classList.toggle("visible");
        gcHeader?.classList.add('hovered');
      } else {
        panel.classList.add("dd-visible");
        panelBg?.classList.add("visible");
        gcHeader?.classList.add('hovered');
      }
    }
    lastClickedButton = isSameButton ? null : item;
  });
});

if (!document.querySelector('.nav-desktop-dd-btn-hover')) {
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.header-nav-desktop-dd-panel') && !event.target.closest('.nav-desktop-dd-btn-clickable') && !event.target.closest('.hdr-search-btn')) {
      document.querySelectorAll('.header-nav-desktop-dd-panel').forEach(panel => panel.classList.remove("dd-visible"));
      panelBg?.classList.remove("visible");
      document.querySelector('.header-bar-inner')?.classList.remove('hovered');
    }
  });
}
